module.exports = __webpack_public_path__ + "static/img/w2.f5fad68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/w2.png
// module id = Nk+0
// module chunks = 1